import React, { useRef, useState } from 'react'
import merge from 'lodash.merge'
import { Sketch as SK } from '@constants'
import { useModalsDispatch } from '@contexts'

export const EditorContext = React.createContext({})

export const EditorContextProvider = (props) => {
  const [state, setState] = useState({
    tool: SK.TOOLS.PENCIL,
    color: {
      fill: '(0,0,0)',
      border: SK.COLOR_PALETTE[3]
    },
    line: {
      width: 3,
      style: 'normal'
    }
  })
  const canvas = useRef()
  const { open: openModal } = useModalsDispatch()

  const setEditorState = (patch) => {
    setState(merge({ ...state }, patch))
  }

  return (
    <EditorContext.Provider
      value={{ state, setEditorState, canvas, openModal }}
    >
      {props.children}
    </EditorContext.Provider>
  )
}
